export const datepicker = {
  colorScheme: {
    light: {
      panel: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        color: '{content.color}',
        borderRadius: '{content.border.radius}',
        shadow: '{overlay.popover.shadow}',
        padding: '{overlay.popover.padding}',
      },
      header: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        color: '{content.color}',
        padding: '0 0 0.5rem 0',
      },
    },
    dark: {
      selectMonth: {
        color: 'white',
      },
      weekDay: {
        color: 'white',
      },

      panel: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        color: 'white',
        borderRadius: '{content.border.radius}',
        shadow: '{overlay.popover.shadow}',
        padding: '{overlay.popover.padding}',
      },
      inputIcon: {
        color: 'white',
      },
      date: {
        color: 'white',
      },
      dropdown: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        color: 'white',
        borderRadius: '{content.border.radius}',
        shadow: '{overlay.popover.shadow}',
        padding: '{overlay.popover.padding}',
        focusRing: {
          color: 'white',
        },
      },
      header: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        color: 'white',
        padding: '0 0 0.5rem 0',
      },
    },
  },
};
